import { Header } from '../../../../components/common/table/Header/Header';
import { HeaderCell } from '../../../../components/common/table/HeaderCell/HeaderCell';
import '../MessageList.scss';

export interface MessageListHeaderProps {}

export function MessageListHeader() {
  return (
    <Header>
      <HeaderCell>{'time'}</HeaderCell>
      <HeaderCell>{'Level'}</HeaderCell>
      <HeaderCell>{'tag'}</HeaderCell>
      <HeaderCell>{'message'}</HeaderCell>
    </Header>
  );
}
